import React, { useState, useEffect, useRef } from 'react';

// --- SVG Icons ---
// Using inline SVGs for icons to keep everything in one file and avoid external dependencies.

const Logo = ({ className }) => (
  <svg className={className} viewBox="0 0 200 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <text x="5" y="35" fontFamily="Inter, sans-serif" fontSize="30" fontWeight="bold" fill="currentColor">
      VERSOLAS
    </text>
  </svg>
);

const IconBrainCircuit = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5a3 3 0 1 0-5.993.299M12 5a3 3 0 1 1 5.993.299M12 12a3 3 0 1 0-5.993.299M12 12a3 3 0 1 1 5.993.299M12 19a3 3 0 1 0-5.993.299M12 19a3 3 0 1 1 5.993.299M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /><path d="M14.5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" /><path d="M12 5v3" /><path d="M12 16v3" />
  </svg>
);

const IconBarChart = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" x2="12" y1="20" y2="10" /><line x1="18" x2="18" y1="20" y2="4" /><line x1="6" x2="6" y1="20" y2="16" />
  </svg>
);

const IconLock = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const IconX = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6 6 18" /><path d="m6 6 12 12" />
    </svg>
);

const IconAward = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6" /><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
    </svg>
);

const IconFileText = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /><path d="M10 9H8" /><path d="M16 13H8" /><path d="M16 17H8" />
    </svg>
);


const LinkedinIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
    </svg>
);

const XIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.617l-5.21-6.817-6.044 6.817h-3.308l7.73-8.805-7.993-11.02h6.793l4.634 6.426 5.432-6.426z" />
    </svg>
);

const YoutubeIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
    </svg>
);


// --- Animated Background for Hero Section ---
const AnimatedBackground = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let animationFrameId;
        let particles = [];

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.size = Math.random() * 2 + 1;
                this.speedX = Math.random() * 1 - 0.5;
                this.speedY = Math.random() * 1 - 0.5;
                this.color = `rgba(107, 114, 128, ${Math.random() * 0.5 + 0.2})`; // Gray-500 with opacity
            }
            update() {
                this.x += this.speedX;
                this.y += this.speedY;
                if (this.size > 0.1) this.size -= 0.01;
            }
            draw() {
                ctx.fillStyle = this.color;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
            }
        }

        const createParticles = () => {
            particles = [];
            const particleCount = (canvas.width * canvas.height) / 10000;
            for (let i = 0; i < particleCount; i++) {
                particles.push(new Particle());
            }
        };

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let i = 0; i < particles.length; i++) {
                particles[i].update();
                particles[i].draw();
                if (particles[i].size <= 0.1) {
                    particles.splice(i, 1);
                    i--;
                    particles.push(new Particle());
                }
            }

            for (let i = 0; i < particles.length; i++) {
                for (let j = i; j < particles.length; j++) {
                    const dx = particles[i].x - particles[j].x;
                    const dy = particles[i].y - particles[j].y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < 100) {
                        ctx.beginPath();
                        ctx.strokeStyle = `rgba(107, 114, 128, ${1 - distance / 100})`;
                        ctx.lineWidth = 0.2;
                        ctx.moveTo(particles[i].x, particles[i].y);
                        ctx.lineTo(particles[j].x, particles[j].y);
                        ctx.stroke();
                    }
                }
            }
            animationFrameId = requestAnimationFrame(animate);
        };
        
        resizeCanvas();
        createParticles();
        animate();
        
        window.addEventListener('resize', () => {
          resizeCanvas();
          createParticles();
        });

        return () => {
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener('resize', resizeCanvas);
        };
    }, []);

    return <canvas ref={canvasRef} className="absolute top-0 left-0 w-full h-full z-0" />;
};


// --- Custom Hook for Scroll Animations ---
const useScrollFadeIn = (threshold = 0.1) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold }
        );

        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref, threshold]);

    return [ref, isVisible];
};

// --- User Session Information Collection ---
const getUserSessionInfo = () => {
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const platform = navigator.platform;
    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timestamp = new Date().toISOString();
    const referrer = document.referrer || 'Direct';
    const currentUrl = window.location.href;
    
    return {
        userAgent,
        language,
        platform,
        screenResolution,
        timezone,
        timestamp,
        referrer,
        currentUrl
    };
};

// --- Animated Counter for Stats ---
const AnimatedCounter = ({ end, duration = 2000 }) => {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                }
            },
            { threshold: 0.5 }
        );

        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    useEffect(() => {
        if (!isInView) return;
        
        let start = 0;
        const startTime = Date.now();

        const step = () => {
            const currentTime = Date.now();
            const progress = Math.min((currentTime - startTime) / duration, 1);
            
            const easedProgress = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            
            setCount(Math.floor(easedProgress * (end - start) + start));

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                setCount(end);
            }
        };
        
        requestAnimationFrame(step);

    }, [end, duration, isInView]);

    return <span ref={ref}>{count}</span>;
};


// --- Components ---

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-sm shadow-md' : 'bg-transparent'}`}>
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <div className="flex flex-col">
                    <button onClick={scrollToTop}>
                        <Logo className={`h-8 transition-colors duration-300 ${isScrolled ? 'text-slate-800' : 'text-white'}`} />
                    </button>
                    <p className={`text-[10px] -mt-2 ml-1.5 font-medium tracking-wider transition-colors duration-300 ${isScrolled ? 'text-slate-500' : 'text-slate-300'}`}>
                        Intelligent Health For Everyone
                    </p>
                </div>
                <nav className="hidden md:flex items-center space-x-8">
                    {['Approach', 'Science', 'Founder', 'Contact'].map(item => (
                        <button key={item} onClick={() => scrollToSection(item.toLowerCase())} className={`text-sm font-medium transition-colors duration-300 ${isScrolled ? 'text-slate-600 hover:text-blue-600' : 'text-slate-200 hover:text-white'}`}>
                            {item}
                        </button>
                    ))}
                </nav>
                 <button onClick={() => scrollToSection('approach')} className={`hidden md:block px-4 py-2 text-sm font-semibold rounded-lg transition-all duration-300 ${isScrolled ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-white/90 text-blue-700 hover:bg-white'}`}>
                    Explore
                </button>
            </div>
        </header>
    );
};

const Hero = () => {
    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };
    
    return (
        <section className="relative h-screen w-full flex items-center justify-center text-white bg-slate-900 overflow-hidden">
            <AnimatedBackground />
            <div className="relative z-10 text-center px-6">
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-4 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                    A clearer path to well-being.
                </h1>
                <p className="max-w-3xl mx-auto text-lg md:text-xl text-slate-300 mb-8 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                    Versolas is pioneering accessible technology for a healthier, more sustainable lifestyle. We develop intelligent health solutions that translate complex biological signals into clear, actionable insights, empowering you to take control of your health journey.
                </p>
                <button onClick={() => scrollToSection('approach')} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg text-lg transition-transform duration-300 transform hover:scale-105 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                    Explore Our Approach
                </button>
            </div>
        </section>
    );
};


const Problem = () => {
    const [ref, isVisible] = useScrollFadeIn();
    
    const problems = [
        {
            icon: <IconBarChart className="h-10 w-10 text-blue-600 mb-4" />,
            title: "Subjective Data",
            description: "Key health decisions often rely on subjective or infrequent data, leaving patients and doctors without a complete picture."
        },
        {
            icon: <IconBrainCircuit className="h-10 w-10 text-blue-600 mb-4" />,
            title: "Invisible Signals",
            description: "The earliest signs of health changes are often invisible, delaying crucial opportunities for proactive care."
        },
        {
            icon: <IconLock className="h-10 w-10 text-blue-600 mb-4" />,
            title: "Barriers to Access",
            description: "Powerful diagnostic technologies are frequently confined to clinics, creating barriers to continuous, real-world monitoring."
        }
    ];

    return (
        <section ref={ref} id="problem" className="py-20 bg-slate-50">
            <div className={`container mx-auto px-6 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Complex health conditions require a clearer understanding.</h2>
                </div>
                <div className="grid md:grid-cols-3 gap-8">
                    {problems.map((problem, index) => (
                         <div key={index} className={`bg-white p-8 rounded-xl shadow-lg transition-all duration-500 delay-${index * 100} ${isVisible ? 'transform translate-y-0 opacity-100' : 'transform translate-y-10 opacity-0'}`}>
                            <div className="flex justify-center md:justify-start">{problem.icon}</div>
                            <h3 className="text-xl font-semibold text-slate-800 mb-2 text-center md:text-left">{problem.title}</h3>
                            <p className="text-slate-600 text-center md:text-left">{problem.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const Initiative = () => {
    const [ref, isVisible] = useScrollFadeIn();

    const steps = [
        { title: "Effortless Data Capture", description: "Our first product features a comfortable, sensor-based wearable that seamlessly captures data on unique movement patterns during everyday life." },
        { title: "Proprietary Analysis", description: "This data is processed by our proprietary AI platform, trained to identify subtle, yet significant, digital biomarkers linked to neurological conditions." },
        { title: "Actionable Insights", description: "Results are delivered through a secure application, providing clear reports that can help you and your healthcare provider make more informed, proactive decisions." }
    ];

    return (
        <section ref={ref} id="approach" className="py-20 bg-white">
            <div className={`container mx-auto px-6 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <div className="text-center mb-12">
                     <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Our First Initiative: A New Lens on Neurological Health</h2>
                </div>
                <div className="relative">
                    {/* The connecting line for desktop */}
                    <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-200 -translate-y-1/2"></div>
                    
                    <div className="relative grid md:grid-cols-3 gap-12">
                        {steps.map((step, index) => (
                            <div key={index} className={`text-center transition-all duration-500 delay-${index * 150} ${isVisible ? 'transform translate-y-0 opacity-100' : 'transform translate-y-10 opacity-0'}`}>
                                <div className="flex items-center justify-center mb-4">
                                    <div className="relative z-10 w-16 h-16 bg-white border-2 border-slate-200 rounded-full flex items-center justify-center">
                                        <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xl">{index + 1}</div>
                                    </div>
                                </div>
                                <h3 className="text-xl font-semibold text-slate-800 mb-2">{step.title}</h3>
                                <p className="text-slate-600">{step.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};


const Validation = () => {
    const [ref, isVisible] = useScrollFadeIn();
    
    const publications = [
      {
        icon: <IconAward className="w-8 h-8 text-blue-500" />,
        title: "ISEF Finalist",
        link: "https://isef.net/project/beha033t-stride-real-time-gait-analysis-for-parkinsons"
      },
      {
        icon: <IconFileText className="w-8 h-8 text-blue-500" />,
        title: "Published Research (arXiv)",
        link: "https://arxiv.org/pdf/2412.00627"
      },
      {
        icon: <IconFileText className="w-8 h-8 text-blue-500" />,
        title: "Published Research (OSF)",
        link: "https://doi.org/10.31219/osf.io/9zyh2"
      }
    ];

    return (
        <section ref={ref} id="science" className="py-20 bg-slate-50">
            <div className={`container mx-auto px-6 transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Validated Science. Tangible Results.</h2>
                </div>
                <div className="grid lg:grid-cols-5 gap-8 items-center">
                    <div className={`lg:col-span-3 bg-white p-8 rounded-xl shadow-lg transition-transform duration-500 ${isVisible ? 'translate-x-0' : '-translate-x-10'}`}>
                       <h3 className="text-2xl font-semibold text-slate-800 mb-4">Unprecedented Accuracy</h3>
                        <p className="text-slate-600">
                           Our platform is built on a foundation of rigorous scientific research. In developing our initial product for neurological health, our AI models achieved extremely high accuracy in classifying motor symptoms during validation studies. This level of precision demonstrates the power of our approach to detect what the human eye might miss.
                        </p>
                    </div>
                    <div className={`lg:col-span-2 text-center transition-transform duration-500 delay-200 ${isVisible ? 'translate-x-0' : 'translate-x-10'}`}>
                        <div className="text-7xl md:text-8xl font-bold text-blue-600">
                            <AnimatedCounter end={91} />%
                        </div>
                        <p className="text-xl text-slate-600 font-medium mt-2">Accuracy Rate</p>
                    </div>
                </div>
                <div className="mt-12">
                     <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-6 text-center">
                         {publications.map((pub, index) => (
                             <a 
                                key={index} 
                                href={pub.link} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className={`block bg-white p-6 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 delay-${index * 150} ${isVisible ? 'transform scale-100 opacity-100' : 'transform scale-95 opacity-0'}`}
                             >
                                 <div className="flex justify-center mb-3">{pub.icon}</div>
                                 <h4 className="font-semibold text-slate-700">{pub.title}</h4>
                             </a>
                         ))}
                    </div>
                </div>
            </div>
        </section>
    );
};


const Founder = () => {
    const [ref, isVisible] = useScrollFadeIn();

    return (
        <section ref={ref} id="founder" className="py-20 bg-white">
            <div className={`container mx-auto px-6 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <div className="grid md:grid-cols-5 gap-12 items-center">
                    <div className="md:col-span-2 flex justify-center">
                         <div className={`w-48 h-48 bg-slate-200 border-4 border-blue-600 rounded-full shadow-lg flex items-center justify-center transition-all duration-500 ${isVisible ? 'transform scale-100' : 'transform scale-90'}`}>
                            <div className="text-blue-600 text-6xl font-bold tracking-tight">
                                RV
                            </div>
                        </div>
                    </div>
                    <div className={`md:col-span-3 transition-all duration-500 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                        <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">A Mission-Driven Founder.</h2>
                        <p className="text-slate-600 mb-4">
                           As a researcher at the intersection of AI, neuroscience, and assistive technology, Rithik Vir was driven to apply his problem-solving skills to real-world health challenges. His work with neurodegenerative diseases and visits to local assisted living centers revealed a critical need for objective, continuous monitoring of health.
                        </p>
                        <p className="text-slate-600">
                           This experience became the inspiration for turning a passion for technology into a mission-driven company, providing the unique blend of skills and vision that is the foundation for Versolas.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

const Vision = () => {
    const [ref, isVisible] = useScrollFadeIn();
    
    return (
        <section ref={ref} className="py-20 bg-slate-800 text-white">
            <div className={`container mx-auto px-6 text-center transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Vision: A Healthier, More Sustainable Lifestyle for All.</h2>
                <p className={`max-w-3xl mx-auto text-slate-300 transition-all duration-500 delay-200 ${isVisible ? 'transform translate-y-0 opacity-100' : 'transform translate-y-10 opacity-0'}`}>
                    At Versolas, we are not just building devices; we are building a future where technology makes proactive health accessible to everyone. Our platform is designed to be adaptable, scalable, and impactful—starting with neurological care and expanding to address a wide spectrum of health and wellness challenges. We are committed to creating a more sustainable and empowered approach to lifelong health.
                </p>
            </div>
        </section>
    );
};

const CTA = () => {
    const [ref, isVisible] = useScrollFadeIn();
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setIsLoading(true);
        setError('');

        try {
            // Collect user session information
            const sessionInfo = getUserSessionInfo();
            
            // Prepare email data for API

            // Log user data to console for development
            console.log('User signup data:', {
                email: email,
                sessionInfo: sessionInfo,
                timestamp: new Date().toISOString()
            });
            
            // Show success message
            setSubmitted(true);
            setEmail('');
            setTimeout(() => setSubmitted(false), 5000);
            
        } catch (error) {
            console.error('Signup failed:', error);
            setError('Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <section ref={ref} id="contact" className="py-20 bg-slate-50">
            <div className={`container mx-auto px-6 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-slate-800">Join Our Journey.</h2>
                </div>
                <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
                    <div className={`bg-white p-8 rounded-xl shadow-lg transition-all duration-500 ${isVisible ? 'transform translate-y-0 opacity-100' : 'transform translate-y-10 opacity-0'}`}>
                        <h3 className="text-xl font-semibold text-slate-800 mb-2">For Patients & Caregivers</h3>
                        <p className="text-slate-600 mb-4">Interested in our first product for neurological health? Join our mailing list for updates and information on early access.</p>
                        <form onSubmit={handleSubmit}>
                            <div className="flex flex-col sm:flex-row gap-2">
                                <input 
                                    type="email" 
                                    placeholder="Your email address" 
                                    className="flex-grow px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:opacity-50"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={isLoading}
                                    required
                                />
                                <button 
                                    type="submit" 
                                    disabled={isLoading}
                                    className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-bold py-2 px-4 rounded-md transition-colors duration-300 flex items-center justify-center min-w-[100px]"
                                >
                                    {isLoading ? (
                                        <div className="flex items-center">
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            Sending...
                                        </div>
                                    ) : (
                                        'Sign Up'
                                    )}
                                </button>
                            </div>
                            {submitted && <p className="text-green-600 text-sm mt-2">Thank you for your interest! We'll be in touch soon.</p>}
                            {error && <p className="text-red-600 text-sm mt-2">{error}</p>}
                        </form>
                    </div>
                    <div className={`bg-white p-8 rounded-xl shadow-lg transition-all duration-500 delay-150 ${isVisible ? 'transform translate-y-0 opacity-100' : 'transform translate-y-10 opacity-0'}`}>
                         <h3 className="text-xl font-semibold text-slate-800 mb-2">For Partners & Investors</h3>
                        <p className="text-slate-600 mb-4">Are you a clinician, researcher, or investor who shares our vision? Let's connect to explore collaboration.</p>
                         <a href="mailto:versolashealth@gmail.com" className="inline-block bg-slate-700 hover:bg-slate-800 text-white font-bold py-2 px-6 rounded-md transition-colors duration-300">
                           Contact Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

const Footer = ({ onLegalLinkClick }) => {
    const socialLinks = [
        { name: 'LinkedIn', icon: <LinkedinIcon className="h-6 w-6" />, url: 'https://www.linkedin.com/in/versolas/' },
        { name: 'X.com', icon: <XIcon className="h-5 w-5" />, url: 'https://x.com/versolashealth' },
        { name: 'YouTube', icon: <YoutubeIcon className="h-6 w-6" />, url: 'https://youtube.com/@versolas' },
    ];
    
    return (
        <footer className="bg-slate-900 text-slate-400">
            <div className="container mx-auto px-6 py-8">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <Logo className="h-8 text-white" />
                        <p className="text-sm mt-2">Versolas LLC, California.</p>
                    </div>
                    <div className="flex space-x-4 mb-4 md:mb-0">
                       {socialLinks.map(social => (
                            <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors duration-300">
                                {social.icon}
                            </a>
                        ))}
                    </div>
                </div>
                <div className="mt-8 border-t border-slate-700 pt-6 flex flex-col sm:flex-row justify-between text-sm">
                    <p className="mb-2 sm:mb-0">© {new Date().getFullYear()} Versolas LLC. All Rights Reserved.</p>
                    <div className="flex space-x-4">
                        <button onClick={() => onLegalLinkClick('privacy')} className="hover:text-white transition-colors duration-300">Privacy Policy</button>
                        <button onClick={() => onLegalLinkClick('terms')} className="hover:text-white transition-colors duration-300">Terms of Service</button>
                        <button onClick={() => onLegalLinkClick('ip')} className="hover:text-white transition-colors duration-300">IP Notice</button>
                    </div>
                </div>
            </div>
        </footer>
    );
};


const LegalModal = ({ content, onClose }) => {
    if (!content) return null;

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="sticky top-0 bg-white border-b border-slate-200 p-4 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-slate-800">{content.title}</h2>
                    <button onClick={onClose} className="text-slate-500 hover:text-slate-800 transition-colors">
                        <IconX className="w-6 h-6" />
                    </button>
                </div>
                <div className="p-6 md:p-8 prose prose-slate max-w-none">
                    {content.body}
                </div>
            </div>
        </div>
    );
};


// Main App Component
export default function App() {
    const [activeLegal, setActiveLegal] = useState(null);

    const legalContent = {
        privacy: {
            title: "Privacy Policy",
            body: (
                <>
                    <p><strong>Effective Date:</strong> August 24, 2025</p>
                    <h4>1. Introduction</h4>
                    <p>Welcome to Versolas LLC. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.</p>
                    <h4>2. Collection of Your Information</h4>
                    <p>We may collect information such as Personal Data (name, email) you voluntarily provide, and Derivative Data (IP address, browser type) collected automatically.</p>
                    <h4>3. Use of Your Information</h4>
                    <p>We use your information to send updates, respond to inquiries, and analyze usage to improve our Site.</p>
                    <h4>4. Disclosure of Your Information</h4>
                    <p>We do not sell your information. We may share it with third-party service providers for tasks like email delivery.</p>
                    <h4>5. Data Security</h4>
                    <p>We use administrative, technical, and physical security measures to protect your personal information.</p>
                    <h4>6. Health Information (Future Use)</h4>
                    <p>Versolas is not currently a covered entity under HIPAA. Should we collect Protected Health Information (PHI) in the future, we will do so in full compliance with all applicable laws.</p>
                    <h4>7. Policy for California Residents (CCPA)</h4>
                    <p>California residents have the right to request information about and deletion of their personal information.</p>
                    <h4>8. Contact Us</h4>
                    <p>If you have questions, please contact us at: Versolas LLC, versolashealth@gmail.com</p>
                </>
            )
        },
        terms: {
            title: "Terms of Service",
            body: (
                <>
                    <p><strong>Last Updated:</strong> August 24, 2025</p>
                    <h4>1. Agreement to Terms</h4>
                    <p>These Terms of Service constitute a legally binding agreement concerning your access to and use of the versolas.com website.</p>
                    <h4>2. NO MEDICAL ADVICE</h4>
                    <p>The information on this website is for informational purposes only and is not a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider.</p>
                    <h4>3. Intellectual Property Rights</h4>
                    <p>The Site and its original content, features, and functionality are owned by Versolas LLC and are protected by international copyright, trademark, and other intellectual property laws.</p>
                    <h4>4. User Representations</h4>
                    <p>By using the Site, you represent that you have the legal capacity to agree to these Terms and will not use the Site for any illegal purpose.</p>
                    <h4>5. Limitation of Liability</h4>
                    <p>In no event will we be liable for any direct, indirect, or consequential damages arising from your use of the site.</p>
                    <h4>6. Governing Law</h4>
                    <p>These Terms are governed by the laws of the State of California.</p>
                </>
            )
        },
        ip: {
            title: "Intellectual Property Notice",
            body: (
                 <>
                    <p><strong>Last Updated:</strong> August 24, 2025</p>
                    <h4>1. Patent Pending Technology</h4>
                    <p>The technology, systems, and methods described on this website are the subject of one or more pending patent applications. Unauthorized use is strictly prohibited.</p>
                    <h4>2. Copyright</h4>
                    <p>© 2025 Versolas LLC. All Rights Reserved. All content on this site is the property of Versolas LLC.</p>
                    <h4>3. Trademarks</h4>
                    <p>The name Versolas, the logo, and all related names and slogans are trademarks of Versolas LLC. You must not use such marks without prior written permission.</p>
                    <h4>4. Ownership of Research and Development</h4>
                    <p>All research, inventions, and algorithms made by Versolas LLC are its sole property, including new IP developed from prior academic research.</p>
                </>
            )
        }
    };

    const handleLegalLinkClick = (page) => {
        setActiveLegal(page);
    };

    const closeLegalModal = () => {
        setActiveLegal(null);
    };
    
    // Add a keydown listener to close the modal with the Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                closeLegalModal();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);


    return (
        <div className="bg-white font-sans text-slate-700 antialiased">
            <Header />
            <main>
                <Hero />
                <Problem />
                <Initiative />
                <Validation />
                <Founder />
                <Vision />
                <CTA />
            </main>
            <Footer onLegalLinkClick={handleLegalLinkClick} />
            <LegalModal content={activeLegal ? legalContent[activeLegal] : null} onClose={closeLegalModal} />
        </div>
    );
}
